(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionStateHistorySearch', HandbookVersionStateHistorySearch);

    HandbookVersionStateHistorySearch.$inject = ['$resource'];

    function HandbookVersionStateHistorySearch($resource) {
        var resourceUrl =  'api/_search/handbook-version-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
